import React, { useEffect, useState } from "react";
//import { useNavigate } from "react-router-dom";
import { useQuery,useQueryClient  } from '@tanstack/react-query'; // Added for TanStack Query
import AppointmentListService from "./Services/AppointmentListService";// New service
import Swal from 'sweetalert2';
import handlePrintPrescription from "./handlePrintPrescription";
import { serverConfig } from "../ApiSearchPath/ApiSearchPath";
import { useLocation } from "react-router-dom";

const Appointment = () => {
  const queryClient = useQueryClient();
  const [activeTab, setActiveTab] = useState("upcoming");
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [dateRange, setDateRange] = useState("");
  const pageSizeOptions = [5, 10, 50, 100, 500, "all"];
  const patientId = +localStorage.getItem('userId'); // Assuming userId is patient createdBy
  const type = "PATIENT";
  const through = "PATIENT";

  useEffect(() => {
    const scriptUrls = [
      "assets/js/jquery-3.7.1.min.js",
      "assets/js/bootstrap.bundle.min.js",
      "assets/plugins/theia-sticky-sidebar/ResizeSensor.js",
      "assets/plugins/theia-sticky-sidebar/theia-sticky-sidebar.js",
      "assets/plugins/select2/js/select2.min.js",
      "assets/js/moment.min.js",
      "assets/plugins/daterangepicker/daterangepicker.js",
      "assets/js/script.js"
    ];

    let isCancelled = false;

    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.async = false;
          script.onload = () => {
            console.log(`Loaded: ${url}`);
            resolve();
          };
          script.onerror = () => {
            console.error(`Failed to load: ${url}`);
            reject();
          };
          document.body.appendChild(script);
        });
      }
      //  const $ = window.jQuery;
      //     const input = $('#bookingrange');
      if (!isCancelled) {
    // We need to wait a tiny bit for the script.js to initialize the daterangepicker
    // or initialize it manually here if script.js doesn't do it automatically
setTimeout(() => {
  const $ = window.jQuery;
  const moment = window.moment;

  if (!$ || !moment) return;

  const picker = $('.bookingrange').data('daterangepicker');

  if (picker) {
    const start = moment();
    const end = moment().add(2, 'months');

    picker.setStartDate(start);
    picker.setEndDate(end);
  }

  $('.bookingrange').off('apply.daterangepicker');

  $('.bookingrange').on('apply.daterangepicker', function (ev, picker) {
    const newRange =
      picker.startDate.format('MM/DD/YYYY') +
      ' - ' +
      picker.endDate.format('MM/DD/YYYY');

    setDateRange(newRange);
    setCurrentPage(0);
  });

}, 1000);
    // setTimeout(() => {
    //   const $ = window.jQuery;
    //   if ($ && $('.bookingrange').length > 0) {
    //     $('.bookingrange').on('apply.daterangepicker', function (ev, picker) {
    //       const newRange = picker.startDate.format('MM/DD/YYYY') + ' - ' + picker.endDate.format('MM/DD/YYYY');
    //       console.log("Date Range Applied:", newRange);
    //       setDateRange(newRange); // This updates the state
    //       setCurrentPage(0);      // Reset to first page
    //     });
    //   }
    // }, 1000); // Small delay to ensure script.js has run
  }
};
    loadScriptsSequentially();

    return () => {
      isCancelled = true;
    };
  }, []);

  // Function to fetch based on tab, date, search, page
  const fetchAppointments = async (tab, fromDate, toDate, searchTerm, page, size) => {
    let response;
    if (searchTerm.length>2) {
      if (tab === "upcoming") {
        response = await AppointmentListService.getAppointmentsBySearchTermPending(searchTerm, fromDate, toDate, patientId, type, page, size);
      } else if (tab === "cancel") {
        response = await AppointmentListService.getAppointmentsBySearchTermDeclined(searchTerm, fromDate, toDate, patientId, type, page, size);
      } else if (tab === "complete") {
        response = await AppointmentListService.getAppointmentsBySearchTermSeen(searchTerm, fromDate, toDate, patientId, type, page, size); 
      } else if (tab === "missing") {
        response = await AppointmentListService.getAppointmentsBySearchTermMissing(searchTerm, fromDate, toDate, patientId, type, page, size);
      }
    } else {
      if (tab === "upcoming") {
        response = await AppointmentListService.fetchAppointmentsByDateForPending(fromDate, toDate, patientId, type, page, size);
        
      } else if (tab === "cancel") {
        response = await AppointmentListService.fetchAppointmentsByDateForDeclined(fromDate, toDate, patientId, type, page, size);
        
      } else if (tab === "complete") {
        response = await AppointmentListService.fetchAppointmentsByDateForSeen(fromDate, toDate, patientId, type, page, size);
      }
      else if (tab === "missing") {
        response = await AppointmentListService.fetchAppointmentsByDateForMissing(fromDate, toDate, patientId, type, page, size);
      }
    }
    return response;
  };

  // Use TanStack Query for fetching
const {
  data,
  isFetching,
  isLoading,
} = useQuery({
  queryKey: [
    'appointments',
    activeTab,
    dateRange,
    searchTerm,
    currentPage,
    pageSize
  ],
  queryFn: async () => {
    const [fromDate, toDate] = dateRange.split(" - ");
    const size =
      pageSize === "all"
        ? 99999
        : pageSize;

    return fetchAppointments(
      activeTab,
      fromDate,
      toDate,
      searchTerm,
      currentPage,
      size
    );
  },
  enabled: !!dateRange,
  keepPreviousData: false, // ⛔ IMPORTANT
});
const appointmentLists = data?.data?.data?.[0] ?? [];
const totalPages = data?.data?.totalPages ?? 0;
const isLoadingAppointments = isLoading || isFetching;
const [tabTotals, setTabTotals] = useState({
  upcoming: 0,
  cancel: 0,
  complete: 0,
  missing: 0,
});
useEffect(() => {
  if (data?.data?.totalElements != null) {
    setTabTotals(prev => ({
      ...prev,
      [activeTab]: data.data.totalElements,
    }));
  }
}, [data, activeTab]);
  // useEffect(() => {
  //   setIsLoading(queryLoading);
  // }, [queryLoading]);

  // Initial date range
  useEffect(() => {
    const today = new Date();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const year = today.getFullYear();
    const formattedToday = `${month}/${day}/${year}`;
    setDateRange(`${formattedToday} - ${formattedToday}`);
    
  }, []);

  const handleTabChange = (tab) => {
    
    setActiveTab(tab);
    setCurrentPage(0);
  };

  const handleDateChange = (e) => {
    setDateRange(e.target.value);
    setCurrentPage(0);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(0);
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
    }
  };
  const handlePrint=(e,id)=>{
    e.preventDefault();
    handlePrintPrescription(id);
  }
  const handlePageSizeChange = (e) => {
    setPageSize(e.target.value);
    setCurrentPage(0);
  };


  const handleCancel = async (apptId) => {
    try {
      await AppointmentListService.changeAppointmentStatus(apptId, "CANCELED", through, patientId);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Appointment cancelled.",
      });
       queryClient.invalidateQueries({
      queryKey: ['appointments'],
    });
    } catch (error) {}
  };
useEffect(() => {
  if (dateRange) {
    console.log('dateRange changed, should trigger refetch:', dateRange);
    queryClient.invalidateQueries({
      queryKey: ['appointments'],
    });
  }
}, [dateRange,queryClient]);
 const { pathname } = useLocation();

useEffect(() => {
  window.scrollTo(0, 0);
}, [pathname]);

  return (
    <div className="col-lg-8 col-xl-9" autoFocus>
      <div className="dashboard-header">
        <h3>Appointments</h3>
        <ul className="header-list-btns">
          <li>
            <div className="input-block dash-search-input">
              <input type="text" className="form-control" placeholder="Search" value={searchTerm} onChange={handleSearchChange} />
              <span className="search-icon"><i className="isax isax-search-normal" /></span>
            </div>
          </li>
        </ul>
      </div>
      <div className="appointment-tab-head">
        <div className="appointment-tabs">
          <ul className="nav nav-pills inner-tab " id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              {/*  */}
              <a href="/" className={`nav-link ${activeTab === 'upcoming' ? 'active' : ''}`} 
              onClick={(e) =>{e.preventDefault(); handleTabChange('upcoming')}} id="pills-upcoming-tab"
               data-bs-toggle="pill" data-bs-target="#pills-upcoming" type="button"
                role="tab" aria-controls="pills-upcoming" aria-selected="false">
                  Upcoming <span>{tabTotals.upcoming}</span></a>
            </li>	
            <li className="nav-item" role="presentation">
              {/* <span>{totalElements}</span> */}
              <a href="/" className={`nav-link ${activeTab === 'cancel' ? 'active' : ''}`}
               onClick={(e) => {e.preventDefault();handleTabChange('cancel')}} id="pills-cancel-tab" 
              data-bs-toggle="pill" data-bs-target="#pills-cancel"
               type="button" role="tab" aria-controls="pills-cancel"
                aria-selected="true">Cancelled <span>{tabTotals.cancel}</span></a>
            </li>
            {/* <span>{totalElements}</span> */}
            <li className="nav-item" role="presentation">
              <a href="/" className={`nav-link ${activeTab === 'complete' ? 'active' : ''}`}
               onClick={(e) =>{e.preventDefault(); handleTabChange('complete')}} id="pills-complete-tab"
                data-bs-toggle="pill" data-bs-target="#pills-complete" type="button"
                 role="tab" aria-controls="pills-complete" aria-selected="true">Completed
                  <span>{tabTotals.complete}</span></a>
            </li>
            {/* <span>{totalElements}</span> */}
            <li className="nav-item" role="presentation">
              <a href="/" className={`nav-link ${activeTab === 'missing' ? 'active' : ''}`}
               onClick={(e) =>{e.preventDefault(); handleTabChange('missing')}} id="pills-missed-tab"
                data-bs-toggle="pill" data-bs-target="#pills-missed" type="button"
                 role="tab" aria-controls="pills-missed" aria-selected="true">Missing
                  <span>{tabTotals.missing}</span></a>
            </li>
          </ul>
        </div>
        <div className="filter-head d-flex align-items-center">
          {appointmentLists.length > 0 && (
            <div className="me-2" style={{ marginBottom: '20px' }}>
              <select className="form-select" style={{ height: '32px', minHeight: '32px', fontSize: '14px', paddingTop: '2px', paddingBottom: '2px', paddingLeft: '10px' }} value={pageSize} onChange={handlePageSizeChange}>
                {pageSizeOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
              </select>
            </div>
          )}
          <div className="position-relative daterange-wraper me-2">
            <div className="input-groupicon calender-input">
              <input type="text" className="form-control date-range bookingrange" placeholder="From Date - To Date " value={dateRange} onChange={handleDateChange}/>
            </div>
            <i className="isax isax-calendar-1" />
          </div>
          
        </div>
      </div>
      <div className="tab-content appointment-tab-content">
        <div className="tab-pane fade show active" id="pills-upcoming" role="tabpanel" aria-labelledby="pills-upcoming-tab">
          {isLoadingAppointments ? (
            <div className="text-center">Loading...</div>
          ) : appointmentLists.length > 0 ? (
            appointmentLists.map((apt) => (
              <div className="appointment-wrap" key={apt.appointmentId}>
                <ul>
                  <li>
                    <div className="patinet-information">
                      <a href="/">
                        <img src={`${serverConfig.BASE_URL}/uploads/${apt.userImage}`} alt="Doctor" onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "assets/img/doctor.png";
  }}/>
                      </a>
                      <div className="patient-info">
                        <p>#Apt{apt.tokenId}</p>
                        <h6><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>{apt.userName}</a></h6>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="patinet-information">
                      <div className="patient-info">
                        <p>#PT{apt.patientNumber}</p>
                        <pre>
                          <h6><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>{apt.patientName}</a></h6><p>Age: {apt.age}</p>
                        </pre>
                      </div>
                    </div>
                  </li>
                  <li className="appointment-info" style={{minWidth:'150px'}}>
                    <p><i className="isax isax-clock5" />{new Date(apt.appointmentDate).toLocaleDateString('en-GB').replaceAll('/', '-')}<br/> {apt.appointmentTime}</p>
                    <ul className="d-flex apponitment-types">
                      <li>{apt.appointmentType}</li>
                      <li>{apt.appointmentMode}</li>
                    </ul>
                  </li>
                  <li className="mail-info-patient" style={{minWidth:'150px'}}>
                    <ul>
                      <li><i className="isax isax-sms5" /><a href={`mailto:${'webnetcare.org'}`}>{'webnetcare.org'}</a></li>
                      <li><i className="isax isax-call5" />{apt.patientPhone}</li>
                    </ul>
                  </li>
                  <li className="appointment-detail-btn d-flex align-items-center gap-3 flex-wrap">
                    <button className="btn" onClick={() => handleCancel(apt.appointmentId)}><i className="isax isax-close-circle5" title='Cancel'/></button>
                  </li>
                </ul>
              </div>
            ))
          ) : (
            <div className="text-center">No Appointments found.</div>
          )}
          {totalPages > 1 && pageSize !== "all" && (
            <div className="pagination dashboard-pagination">
              <ul>
                <li>
                  <a href="/" role="button" className="page-link prev-link" onClick={(e) =>{e.preventDefault(); handlePageChange(currentPage - 1)}} disabled={currentPage === 0}><i className="fa-solid fa-chevron-left me-2" />Prev</a>
                </li>
                {[...Array(totalPages).keys()].map((page) => (
                  <li key={page}>
                    <a href="/" role="button" className={`page-link ${currentPage === page ? 'active' : ''}`} onClick={(e) =>{e.preventDefault(); handlePageChange(page)}}>{page + 1}</a>
                  </li>
                ))}
                <li>
                  <a href="/" role="button" className="page-link next-link" onClick={(e) =>{e.preventDefault(); handlePageChange(currentPage + 1)}} disabled={currentPage === totalPages - 1}>Next<i className="fa-solid fa-chevron-right ms-2" /></a>
                </li>
              </ul>
            </div>
          )}

        </div>
        {/* Similar structure for other tabs, with apt data binding */}
        {/* For cancel tab */}
        <div className="tab-pane fade" id="pills-cancel" role="tabpanel" aria-labelledby="pills-cancel-tab">
          {/* Similar list rendering as above, but with Canceled button */}
          {isLoadingAppointments ? (
            <div className="text-center">Loading...</div>
          ) : appointmentLists.length > 0 ? (
            appointmentLists.map((apt) => (
              <div className="appointment-wrap" key={apt.appointmentId}>
              <ul>
                  <li>
                    <div className="patinet-information">
                      <a href="/">
                        <img src={`${serverConfig.BASE_URL}/uploads/${apt.userImage}`} alt="Doctor" 
                        onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "assets/img/doctor.png";
  }}/>
                      </a>
                      <div className="patient-info">
                        <p>#Apt{apt.tokenId}</p>
                        <h6><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>{apt.userName}</a></h6>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="patinet-information" style={{minWidth:'150px'}}>
                      <div className="patient-info">
                        <p>#PT{apt.patientNumber}</p>
                        <pre>
                          <h6><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>{apt.patientName}</a></h6><p>Age: {apt.age}</p>
                        </pre>
                      </div>
                    </div>
                  </li>
                  <li className="appointment-info" style={{minWidth:'150px'}}>
                    <p><i className="isax isax-clock5" />{new Date(apt.appointmentDate).toLocaleDateString('en-GB').replaceAll('/', '-')} {apt.appointmentTime}</p>
                    <ul className="d-flex apponitment-types">
                      <li>{apt.appointmentType}</li>
                      <li>{apt.appointmentMode}</li>
                    </ul>
                  </li>
              <li className="appointment-detail-btn">
                <a href="/" role="button" onClick={(e)=>{e.preventDefault()}} className="btn btn-md btn-primary-gradient"><i className="isax isax-calendar-tick5 me-1" />Canceled</a>
              </li>
              </ul>
              </div>
            ))
          ) : (
            <div className="text-center">No Appointments found.</div>
          )}
           {totalPages > 1 && pageSize !== "all" && (
            <div className="pagination dashboard-pagination">
              <ul>
                <li>
                  <a href="/" role="button" className="page-link prev-link" onClick={(e) =>{e.preventDefault(); handlePageChange(currentPage - 1)}} disabled={currentPage === 0}><i className="fa-solid fa-chevron-left me-2" />Prev</a>
                </li>
                {[...Array(totalPages).keys()].map((page) => (
                  <li key={page}>
                    <a href="/" role="button" className={`page-link ${currentPage === page ? 'active' : ''}`} onClick={(e) =>{e.preventDefault(); handlePageChange(page)}}>{page + 1}</a>
                  </li>
                ))}
                <li>
                  <a href="/" role="button" className="page-link next-link" onClick={(e) =>{e.preventDefault(); handlePageChange(currentPage + 1)}} disabled={currentPage === totalPages - 1}>Next<i className="fa-solid fa-chevron-right ms-2" /></a>
                </li>
              </ul>
            </div>
          )}

        </div>
        {/* For complete tab */}
        <div className="tab-pane fade" id="pills-complete" role="tabpanel" aria-labelledby="pills-complete-tab">
          {/* Similar, with Book Again and Prescriptions */}
          {isLoadingAppointments ? (
            <div className="text-center">Loading...</div>
          ) : appointmentLists.length > 0 ? (
            appointmentLists.map((apt) => (
              <div className="appointment-wrap" key={apt.appointmentId}>
                <ul>
                  <li>
                    <div className="patinet-information">
                      <a href="/">
                        <img src={`${serverConfig.BASE_URL}/uploads/${apt.userImage}`} alt="Doctor" 
                        onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "assets/img/doctor.png";
  }}/>
                      </a>
                      <div className="patient-info">
                        <p>#Apt{apt.tokenId}</p>
                        <h6><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>{apt.userName}</a></h6>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="patinet-information">
                      <div className="patient-info">
                        <p>#PT{apt.patientNumber}</p>
                        <pre>
                          <h6><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>{apt.patientName}</a></h6>
                          <br/>
                          <p>Age: {apt.age}</p>
                        </pre>
                      </div>
                    </div>
                  </li>
                  <li className="appointment-info" style={{minWidth:'150px'}}>
                    <p><i className="isax isax-clock5" />{new Date(apt.appointmentDate).toLocaleDateString('en-GB').replaceAll('/', '-')}<br/> {apt.appointmentTime}</p>
                    <ul className="d-flex apponitment-types">
                      <li>{apt.appointmentType}</li>
                      <li>{apt.appointmentMode}</li>
                    </ul>
                  </li>
              {/* d-flex gap-3 flex-wrap*/}
              <li className="appointment-detail-btn align-items-center">
                <a href={`/doctor-profile?query=${apt.userId}`} className="btn btn-md btn-dark">Book Again<i className="isax isax-arrow-right-3 ms-1" /></a>
                <br/>
                <button className="btn btn-md btn-primary-gradient" onClick={(e)=>handlePrint(e,apt.appointmentId)}>Prescriptions<i className="isax isax-arrow-right-3 ms-1" /></button>
              </li>
              </ul>
              </div>
            ))
          ) : (
            <div className="text-center">No Appointments found.</div>
          )}
           {totalPages > 1 && pageSize !== "all" && (
            <div className="pagination dashboard-pagination">
              <ul>
                <li>
                  <a href="/" role="button" className="page-link prev-link" onClick={(e) =>{e.preventDefault(); handlePageChange(currentPage - 1)}} disabled={currentPage === 0}><i className="fa-solid fa-chevron-left me-2" />Prev</a>
                </li>
                {[...Array(totalPages).keys()].map((page) => (
                  <li key={page}>
                    <a href="/" role="button" className={`page-link ${currentPage === page ? 'active' : ''}`} onClick={(e) =>{e.preventDefault(); handlePageChange(page)}}>{page + 1}</a>
                  </li>
                ))}
                <li>
                  <a href="/" role="button" className="page-link next-link" onClick={(e) =>{e.preventDefault(); handlePageChange(currentPage + 1)}} disabled={currentPage === totalPages - 1}>Next<i className="fa-solid fa-chevron-right ms-2" /></a>
                </li>
              </ul>
            </div>
          )}

        </div>

        {/* For missed tab */}
        <div className="tab-pane fade" id="pills-missed" role="tabpanel" aria-labelledby="pills-missed-tab">
          {/* Similar, with Book Again and Prescriptions */}
          {isLoadingAppointments ? (
            <div className="text-center">Loading...</div>
          ) : appointmentLists.length > 0 ? (
            appointmentLists.map((apt) => (
              <div className="appointment-wrap" key={apt.appointmentId}>
                <ul>
                  <li>
                    <div className="patinet-information">
                      <a href="/">
                        <img src={`${serverConfig.BASE_URL}/uploads/${apt.userImage}`} alt="Doctor" 
                        onError={(e) => {
    e.target.onerror = null; // prevents infinite loop
    e.target.src = "assets/img/doctor.png";
  }}/>
                      </a>
                      <div className="patient-info">
                        <p>#Apt{apt.tokenId}</p>
                        <h6><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>{apt.userName}</a></h6>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="patinet-information">
                      <div className="patient-info">
                        <p>#PT{apt.patientNumber}</p>
                        <pre>
                          <h6><a href="/" role="button" onClick={(e)=>{e.preventDefault()}}>{apt.patientName}</a></h6>
                          <br/>
                          <p>Age: {apt.age}</p>
                        </pre>
                      </div>
                    </div>
                  </li>
                  <li className="appointment-info" style={{minWidth:'150px'}}>
                    <p><i className="isax isax-clock5" />{new Date(apt.appointmentDate).toLocaleDateString('en-GB').replaceAll('/', '-')}<br/> {apt.appointmentTime}</p>
                    <ul className="d-flex apponitment-types">
                      <li>{apt.appointmentType}</li>
                      <li>{apt.appointmentMode}</li>
                    </ul>
                  </li>
              {/* d-flex gap-3 flex-wrap*/}
              <li className="appointment-detail-btn align-items-center">
                <a href={`/doctor-profile?query=${apt.userId}`} className="btn btn-md btn-dark">Reshedule<i className="isax isax-arrow-right-3 ms-1" /></a>
              </li>
              </ul>
              </div>
            ))
          ) : (
            <div className="text-center">No Appointments found.</div>
          )}
           {totalPages > 1 && pageSize !== "all" && (
            <div className="pagination dashboard-pagination">
              <ul>
                <li>
                  <a href="/" role="button" className="page-link prev-link" onClick={(e) =>{e.preventDefault(); handlePageChange(currentPage - 1)}} disabled={currentPage === 0}><i className="fa-solid fa-chevron-left me-2" />Prev</a>
                </li>
                {[...Array(totalPages).keys()].map((page) => (
                  <li key={page}>
                    <a href="/" role="button" className={`page-link ${currentPage === page ? 'active' : ''}`} onClick={(e) =>{e.preventDefault(); handlePageChange(page)}}>{page + 1}</a>
                  </li>
                ))}
                <li>
                  <a href="/" role="button" className="page-link next-link" onClick={(e) =>{e.preventDefault(); handlePageChange(currentPage + 1)}} disabled={currentPage === totalPages - 1}>Next<i className="fa-solid fa-chevron-right ms-2" /></a>
                </li>
              </ul>
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default Appointment;